import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import ActionCable from 'actioncable'
Vue.prototype.$cable = {}

import Notifications from 'vue-notification'
Vue.use(Notifications)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import Clipboard from 'v-clipboard'
Vue.use(Clipboard)

import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import {
  Settings
} from 'luxon'
Settings.defaultLocale = 'pt-BR'
Vue.use(Datetime)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'nprogress/nprogress.css'

import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics'

import vbclass from 'vue-body-class'
Vue.use(vbclass, router)

Vue.use(VueAnalytics, {
  id: 'UA-19971072-18',
  router,
  autoTracking: {
    pageviewTemplate(route) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href
      }
    }
  },
  debug: {
    sendHitTask: window.location.hostname == 'queota.club'
  }
})

// TODO melhorar esse código feio aqui
var url = new URL(window.location.href);
var token = url.searchParams.get("token");
if (token) {
  localStorage.setItem('token', token);
  store.dispatch('login', token)
    .then(() => {
      window.history.pushState('', '', window.location.href.split('?')[0])
    })
  
  
}

if (store.getters.isLoggedIn) {
  var API_URL = (window.location.hostname == 'queota.club') ? 'https://api.queota.club' : 'http://localhost:5000';
  Vue.prototype.$cable = ActionCable.createConsumer(API_URL + "/cable?token=" + store.getters.token);

  if (store && store.getters && store.getters.user && store.getters.email) {
    if (__insp !== undefined && window.location.hostname == 'queota.club')
      __insp.push(['identify', store.getters.user.email])
    if (FS !== undefined && window.location.hostname == 'queota.club')
      FS.identify(store.getters.user.id, {
        displayName: store.getters.user.nickname,
        email: store.getters.user.email,
      })
  }
}

import App from './App.vue'
import './registerServiceWorker'

import VueAxios from 'vue-axios'
import axios from './services/base'
Vue.use(VueAxios, axios)

import CKEditor from '@ckeditor/ckeditor5-vue'
Vue.use(CKEditor)

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

import VueGlide from 'vue-glide-js'
import 'vue-glide-js/dist/vue-glide.css'
Vue.use(VueGlide)

import Ads from 'vue-google-adsense'
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)

import Helpers from './helpers/base.mixins'
Vue.mixin(Helpers)

Vue.config.productionTip = false

window.addEventListener('storage', function (e) {
  if (e.key !== 'queotaClub') {
    // console.log('Ignored an event: ', e)
    return
  }
  var vuexJSON = JSON.parse(localStorage['queotaClub'])
  store.replaceState(vuexJSON)
}, false)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
